import React from "react";
import { Link, useLocation } from "@reach/router";
import { List, ListItem, ListItemIcon, ListItemText, Divider } from "@material-ui/core";
import {
  Dashboard,
  Assignment,
  Payment,
  Flag,
  QuestionAnswer,
  Description,
  List as ListIcon,
  Business,
  Home,
  People,
  CloudUpload,
  ExitToApp,
} from "@material-ui/icons";
import { useViewer } from "components/viewer/context";

const styles = {
  logo: {
    width: 52,
    height: 58,
    backgroundImage: "url(https://s3.amazonaws.com/hc-images2/haven_logo_light.png)",
    backgroundSize: "237px 58px",
    display: "inline-block",
    marginBottom: "1em",
  },
  sidebar: {
    backgroundColor: "#32445A",
    minHeight: "100vh",
    padding: "1em",
  },
  username: {
    color: "whitesmoke",
    textAlign: "center" as const,
    display: "block",
    marginTop: "1em",
  },
};

const SideBarLink = ({ to, children, icon: Icon }: { to: string; children: React.ReactNode; icon: any }) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(to);

  return (
    <ListItem
      button
      component={Link}
      to={to}
      selected={isActive}
      style={{ color: "white" }}
    >
      <ListItemIcon style={{ color: "white", minWidth: "40px" }}>
        <Icon />
      </ListItemIcon>
      <ListItemText
        primary={children}
        primaryTypographyProps={{ style: { color: "white" } }}
      />
    </ListItem>
  );
};

const SideBar: React.FC = () => {
  const viewer = useViewer();

  if (!viewer) return <p>Server Error fetching Viewer</p>;

  return (
    <List style={styles.sidebar} role="navigation">
      <ListItem>
        <Link to="/dash/admin" className="text-center">
          <span style={styles.logo} />
        </Link>
      </ListItem>

      <Divider style={{ backgroundColor: "rgba(255,255,255,0.1)" }} />

      <SideBarLink to="/dash/admin" icon={Dashboard}>Overview</SideBarLink>
      <SideBarLink to="/dash/admin/interests" icon={Assignment}>Applications</SideBarLink>
      <SideBarLink to="/dash/admin/billing" icon={Payment}>Billing</SideBarLink>
      <SideBarLink to="/dash/admin/feature-flags" icon={Flag}>Feature Flags</SideBarLink>
      <SideBarLink to="/dash/admin/form-questions" icon={QuestionAnswer}>Form Questions</SideBarLink>
      <SideBarLink to="/dash/admin/forms" icon={Description}>Form Drafts</SideBarLink>
      <SideBarLink to="/dash/admin/lists" icon={ListIcon}>Lists</SideBarLink>
      <SideBarLink to="/dash/admin/organizations" icon={Business}>Organizations</SideBarLink>
      <SideBarLink to="/dash/admin/properties" icon={Home}>Properties</SideBarLink>
      <SideBarLink to="/dash/admin/users" icon={People}>Users</SideBarLink>
      <SideBarLink to="/dash/admin/importers/lottery" icon={CloudUpload}>Lottery Importer</SideBarLink>
      <SideBarLink to="/dash/admin/importers/waitlist" icon={CloudUpload}>Waitlist Importer</SideBarLink>

      <Divider style={{ backgroundColor: "rgba(255,255,255,0.1)", marginTop: "1em" }} />

      <ListItem
        button
        component={Link}
        to="/logout"
        style={{ color: "white" }}
      >
        <ListItemIcon style={{ color: "white", minWidth: "40px" }}>
          <ExitToApp />
        </ListItemIcon>
        <ListItemText
          primary="Log Out"
          primaryTypographyProps={{ style: { color: "white" } }}
        />
      </ListItem>

      <small style={styles.username}>{viewer.logins[0].username}</small>
    </List>
  );
};

export default SideBar;
